/* SIXAMPM Redesign — Interaktionen. Kein Framework, keine Abhängigkeiten.
 *
 * Portiert aus der Design-Lieferung (assets/sixampm.js), mit drei Korrekturen:
 *
 * 1. Doppelbindung. Das Original ruft init() erneut bei jedem
 *    shopify:section:load auf und hängt dabei ein zweites Mal Listener an
 *    dieselben Elemente — im Theme-Editor klappte danach jedes Akkordeon
 *    zweimal um, also gar nicht. Jedes Element wird jetzt einmalig über
 *    data-sx2-bound markiert.
 * 2. Preisformat. Das Original ersetzt nur {{amount}}. Ein deutscher Shop
 *    nutzt {{amount_with_comma_separator}} — die Ersetzung lief ins Leere und
 *    die Bundle-Summe zeigte den rohen Formatstring. Jetzt werden alle
 *    gängigen Shopify-Money-Token bedient.
 * 3. Uhr und Scroll. setInterval und der Scroll-Listener wurden bei jedem
 *    Section-Reload neu gestartet, ohne die alten abzuräumen.
 *
 * Mega-Menü und Varianten sind am 14.08. dazugekommen, weil Header und
 * Produktseite jetzt 1:1 aus der Lieferung stammen. Beide mit je einer
 * Ergänzung: das Menü hält den Tabfokus im Overlay und gibt ihn beim
 * Schließen an den Auslöser zurück, der Varianten-Umschalter schaltet den
 * Kaufknopf auf „Ausverkauft" statt ihn kaufbar zu lassen.
 */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /** Bindet fn genau einmal pro Element. */
  function once(el, key, fn) {
    if (!el) return false;
    var flag = 'sx2' + key;
    if (el.dataset[flag]) return false;
    el.dataset[flag] = '1';
    fn(el);
    return true;
  }

  function each(sel, fn, scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll(sel), fn);
  }

  /* --- Geld ------------------------------------------------------------- */

  function group(intStr, sep) {
    return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  /**
   * Formatiert Cent nach Shopifys money_format.
   * Deckt alle Token ab, die Shopify ausliefert — nicht nur {{amount}}.
   */
  function formatMoney(cents, format) {
    var numeric = Number(cents);
    if (!Number.isFinite(numeric)) return '';
    var value = Math.round(numeric) / 100;
    var fmt = format || '{{amount}}';

    function build(decimals, thousandsSep, decimalSep) {
      var fixed = Math.abs(value).toFixed(decimals);
      var parts = fixed.split('.');
      var out = group(parts[0], thousandsSep);
      if (decimals > 0) out += decimalSep + parts[1];
      return (value < 0 ? '-' : '') + out;
    }

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      switch (token) {
        case 'amount': return build(2, ',', '.');
        case 'amount_no_decimals': return build(0, ',', '.');
        case 'amount_with_comma_separator': return build(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return build(0, '.', ',');
        case 'amount_with_apostrophe_separator': return build(2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return build(0, ' ', '.');
        case 'amount_with_space_separator': return build(2, ' ', ',');
        case 'amount_with_period_and_space_separator': return build(2, ' ', '.');
        default: return build(2, ',', '.');
      }
    });
  }

  // Sections brauchen denselben Formatierer — einmal zentral bereitstellen,
  // statt in jeder Section eine eigene, meist falsche Variante zu bauen.
  window.SX2 = window.SX2 || {};
  window.SX2.money = formatMoney;

  /* --- Scroll-Reveal ---------------------------------------------------- */

  function reveal() {
    var els = document.querySelectorAll('[data-sx-reveal]:not(.is-in)');
    if (!els.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    Array.prototype.forEach.call(els, function (el) {
      // Was beim Laden schon im Bild ist, wird sofort gezeigt — sonst
      // bleibt der obere Seitenbereich unsichtbar, bis jemand scrollt.
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) {
        el.classList.add('is-in');
        return;
      }
      io.observe(el);
    });
  }

  /* --- Hero-Uhr --------------------------------------------------------- */

  var clockTimer = null;

  function clock() {
    var box = document.querySelector('[data-sx-clock]');
    if (!box) {
      if (clockTimer) { clearInterval(clockTimer); clockTimer = null; }
      return;
    }

    var time = box.querySelector('[data-sx-clock-time]');
    var phase = box.querySelector('[data-sx-clock-phase]');
    var amLabel = box.getAttribute('data-label-am') || '6:AM';
    var pmLabel = box.getAttribute('data-label-pm') || '6:PM';

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var d = new Date();
      var h = d.getHours();
      if (time) time.textContent = pad(h) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
      var isAm = h >= 6 && h < 18;
      /* Der Punkt traegt die Tagesfarbe, das Label bleibt Sand: 10-px-Mono in
         Gelb ueber einem Kampagnenfoto waere Gluecksache, ein Punkt nicht.
         Kein innerHTML — die Labels sind Haendler-Text aus dem Theme-Editor. */
      if (phase) {
        phase.textContent = '';
        var dot = document.createElement('span');
        dot.className = 'sx-hero__dot';
        dot.setAttribute('aria-hidden', 'true');
        dot.textContent = '\u25CF';
        phase.appendChild(dot);
        phase.appendChild(document.createTextNode(' ' + (isAm ? amLabel : pmLabel)));
      }
      /* Grenze 6/18 ist die Marke. layout/theme.liquid setzt das Attribut beim
         ersten Paint, hier laeuft es mit — sonst haengt eine ueber Nacht offene
         Seite auf der Farbe von gestern. */
      document.documentElement.setAttribute('data-daypart', isAm ? 'am' : 'pm');
    }

    tick();
    if (clockTimer) clearInterval(clockTimer);
    clockTimer = setInterval(tick, 1000);
  }

  /* --- Akkordeon (PDP, FAQ) --------------------------------------------- */

  function accordions() {
    each('[data-sx-acc]', function (grp) {
      var single = grp.getAttribute('data-sx-acc') === 'single';

      each('[data-sx-acc-item]', function (item) {
        var btn = item.querySelector('[data-sx-acc-btn]');
        if (!btn) return;

        once(btn, 'Acc', function () {
          var body = item.querySelector('.sx-acc__body, .sx-faq__a');
          if (body && !body.id) body.id = 'sx2-acc-' + Math.random().toString(36).slice(2, 9);
          btn.setAttribute('aria-expanded', item.getAttribute('data-open') === 'true' ? 'true' : 'false');
          if (body) btn.setAttribute('aria-controls', body.id);

          btn.addEventListener('click', function () {
            var isOpen = item.getAttribute('data-open') === 'true';

            if (single && !isOpen) {
              /* Rahmen des Ausschlusses: ein gemeinsamer [data-sx-acc-scope]
                 darüber, sonst die eigene Gruppe. Auf der Produktseite ist jede
                 Akkordeon-Zeile ein eigener Block mit eigener Gruppe — ohne
                 den gemeinsamen Rahmen blieben mehrere Zeilen offen, die
                 Lieferung „Tanrevel" verlangt genau eine (22.09.2026). */
              var scope = grp.closest('[data-sx-acc-scope]') || grp;
              each('[data-sx-acc-item]', function (other) {
                if (other === item) return;
                other.setAttribute('data-open', 'false');
                var ob = other.querySelector('[data-sx-acc-btn]');
                if (ob) ob.setAttribute('aria-expanded', 'false');
                var oi = other.querySelector('i');
                if (oi) oi.textContent = '+';
              }, scope);
            }

            item.setAttribute('data-open', isOpen ? 'false' : 'true');
            btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
            var icon = item.querySelector('i');
            if (icon) icon.textContent = isOpen ? '+' : '−';
          });
        });
      }, grp);
    });
  }

  /* --- Mega-Menü -------------------------------------------------------- */

  /**
   * Vollbild-Menü aus sections/mega-menu-overlay.liquid der Lieferung.
   * Gegenüber dem Original: Fokus wandert beim Öffnen ins Overlay und beim
   * Schließen zurück auf den Auslöser, und der Tabfokus bleibt drin —
   * ohne das ist das Menü per Tastatur nicht bedienbar (Handoff §4).
   */
  function menu() {
    var panel = document.querySelector('[data-sx-mega]');
    if (!panel) return;

    var opener = null;

    function focusables() {
      return Array.prototype.filter.call(panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'), function (el) { return el.getClientRects().length && !el.closest('[hidden]'); });
    }

    function set(open) {
      panel.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
      each('[data-sx-mega-toggle]', function (b) {
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      if (open) {
        var first = focusables()[0];
        if (first) first.focus();
      } else if (opener) {
        opener.focus();
      }
    }

    each('[data-sx-mega-toggle]', function (btn) {
      once(btn, 'Mega', function () {
        btn.addEventListener('click', function () {
          if (panel.hidden) opener = btn;
          set(panel.hidden);
        });
      });
    });

    once(panel, 'MegaKeys', function () {
      document.addEventListener('keydown', function (e) {
        if (!panel.isConnected || panel.hidden) return;
        if (e.key === 'Escape') { set(false); return; }
        if (e.key !== 'Tab') return;

        var items = focusables();
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    });
  }

  /* --- Varianten -------------------------------------------------------- */

  /**
   * Varianten-Umschalter aus sections/main-product.liquid der Lieferung.
   * Gegenüber dem Original: ausverkaufte Varianten schalten den Kaufknopf
   * um, statt ihn stillschweigend kaufbar zu lassen.
   */
  function variants() {
    var root = document.querySelector('[data-sx-variants]');
    if (!root) return;

    var input = document.querySelector('[data-sx-variant-input]');
    var shot = document.querySelector('[data-sx-main-image]');

    each('[data-variant-id]', function (btn) {
      once(btn, 'Variant', function () {
        btn.addEventListener('keydown', function (event) {
          var options = Array.prototype.slice.call(root.querySelectorAll('[data-variant-id]'));
          var index = options.indexOf(btn);
          var next;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % options.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + options.length - 1) % options.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = options.length - 1;
          else return;
          event.preventDefault();
          options[next].click();
          options[next].focus();
        });
        btn.addEventListener('click', function () {
          each('[data-variant-id]', function (b) { b.setAttribute('aria-checked', 'false'); }, root);
          btn.setAttribute('aria-checked', 'true');

          var id = btn.getAttribute('data-variant-id');
          if (input) input.value = id;

          var img = btn.getAttribute('data-variant-image');
          if (shot && img) {
            shot.src = img;
            var imageAlt = btn.getAttribute('data-variant-image-alt');
            if (imageAlt !== null) shot.alt = imageAlt;
            shot.removeAttribute('srcset');
            // Die Galerie steht vielleicht auf einer anderen Folie — sie muss
            // zurueck auf die erste, sonst bleibt der Wechsel unsichtbar.
            var stage = shot.closest('[data-sx-stage]');
            if (stage) stage.dispatchEvent(new CustomEvent('sx:variant-image'));
          }

          var available = btn.getAttribute('data-variant-available') !== 'false';
          each('[data-sx-atc]', function (atc) {
            atc.disabled = !available;
            atc.setAttribute('aria-disabled', available ? 'false' : 'true');
            var label = atc.getAttribute('data-label-' + (available ? 'available' : 'soldout'));
            if (label) {
              var labelNode = atc.querySelector('[data-sx-atc-label]');
              if (labelNode) {
                labelNode.textContent = label;
                var labelTotal = atc.querySelector('[data-sx-atc-total]');
                if (labelTotal) labelTotal.hidden = !available;
                var separator = atc.querySelector('[data-sx-atc-separator]');
                if (separator) separator.hidden = !available;
              }
              else {
                var totalNode = atc.querySelector('[data-sx-atc-total]');
                atc.textContent = label;
                if (totalNode) {
                  if (available) atc.appendChild(document.createTextNode(' — '));
                  totalNode.hidden = !available;
                  atc.appendChild(totalNode);
                }
              }
            }
          });

          var price = Number(btn.getAttribute('data-variant-price'));
          var targets = {
            'price': 'price-formatted', 'compare-price': 'compare-at-formatted',
            'unit-price': 'unit-price', 'content-size': 'content-size', 'variant-title': 'title'
          };
          Object.keys(targets).forEach(function (key) {
            var value = btn.getAttribute('data-variant-' + targets[key]) || '';
            each('[data-sx-' + key + ']', function (el) { el.textContent = value; el.hidden = !value;
              if (key === 'content-size') { var container = el.closest('[data-sx-size-container]'); if (container) container.hidden = !value; } });
          });
          each('[data-sx-savings]', function (el) {
            var saving = Number(btn.getAttribute('data-variant-savings')) || 0;
            el.textContent = saving > 0 ? saving + ' % sparen' : '';
            el.hidden = saving <= 0;
          });
          each('[data-sx-availability]', function (el) { el.textContent = available ? ' · Verfügbar' : ' · Ausverkauft'; });
          each('[data-sx-bundle]', function (el) {
            if (Number.isFinite(price)) el.setAttribute('data-base-price', price);
          });
          if (Number.isFinite(price)) {
            each('[data-sx-atc-total]', function (el) { el.textContent = btn.getAttribute('data-variant-price-formatted') || ''; });
          }
          var quantityInput = document.querySelector('[data-sx-qty]');
          if (quantityInput) {
            quantityInput.min = btn.getAttribute('data-variant-quantity-min') || '1';
            quantityInput.step = btn.getAttribute('data-variant-quantity-increment') || '1';
            quantityInput.max = btn.getAttribute('data-variant-quantity-max') || '';
            quantityInput.value = quantityInput.min;
          }
          each('[data-variant-id]', function (option) { option.tabIndex = option === btn ? 0 : -1; }, root);
          if (input) input.dispatchEvent(new Event('change', { bubbles: true }));

          var url = new URL(window.location);
          url.searchParams.set('variant', id);
          window.history.replaceState({}, '', url);
          document.dispatchEvent(new CustomEvent('sx:variant', { detail: { id: id } }));
        });
      });
    }, root);
  }

  /* --- Galerie ---------------------------------------------------------- */

  /* Die Galerie ist eine Bahn mit Folien (scroll-snap), keine Bildertausch-
     Maschine mehr. Damit macht das Telefon von sich aus das Richtige: wischen.
     Der Code hier tut nur noch zwei Dinge — die Leiste scrollt die Bahn, und
     die Bahn meldet zurueck, welche Folie gerade steht. */

  function gallery() {
    each('[data-sx-stage]', function (stage) {
      once(stage, 'Stage', function () {
        var slides = [].slice.call(stage.querySelectorAll('[data-sx-slide]'));
        if (slides.length < 2) return;

        // Die Leiste ist Geschwister des RAHMENS, nicht der Bahn.
        var galerie = stage.closest('.sx-pdp__gallery') || stage.parentNode;
        var rail = galerie.querySelector('.sx-pdp__rail');
        var thumbs = rail ? [].slice.call(rail.querySelectorAll('[data-sx-thumb]')) : [];

        var sanft = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        function zeige(i) {
          if (i < 0 || i >= slides.length) return;
          stage.scrollTo({ left: slides[i].offsetLeft - stage.offsetLeft,
                           behavior: sanft ? 'smooth' : 'auto' });
        }

        function markiere(i) {
          thumbs.forEach(function (t, n) {
            t.setAttribute('aria-current', n === i ? 'true' : 'false');
          });
          // Bei vielen Ansichten laeuft die aktive aus der Leiste heraus.
          if (thumbs[i] && rail && rail.scrollHeight > rail.clientHeight) {
            var t = thumbs[i], oben = t.offsetTop - rail.offsetTop;
            if (oben < rail.scrollTop || oben + t.offsetHeight > rail.scrollTop + rail.clientHeight) {
              rail.scrollTo({ top: oben, behavior: sanft ? 'smooth' : 'auto' });
            }
          }
        }

        thumbs.forEach(function (thumb, i) {
          thumb.addEventListener('click', function () { zeige(i); markiere(i); });
        });

        // Pfeiltasten bewegen eine ganze Folie. Ohne das scrollt der Browser in
        // kleinen Schritten und der Schnappunkt zieht wieder zurueck.
        stage.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          var jetzt = aktiv();
          zeige(jetzt + (e.key === 'ArrowRight' ? 1 : -1));
        });

        function aktiv() {
          var mitte = stage.scrollLeft + stage.clientWidth / 2, i = 0, best = Infinity;
          slides.forEach(function (s, n) {
            var d = Math.abs((s.offsetLeft - stage.offsetLeft) + s.offsetWidth / 2 - mitte);
            if (d < best) { best = d; i = n; }
          });
          return i;
        }

        if ('IntersectionObserver' in window) {
          var beobachter = new IntersectionObserver(function (eintraege) {
            eintraege.forEach(function (e) {
              if (e.isIntersecting && e.intersectionRatio > 0.55) {
                markiere(slides.indexOf(e.target));
              }
            });
          }, { root: stage, threshold: [0.56] });
          slides.forEach(function (s) { beobachter.observe(s); });
        } else {
          var warte;
          stage.addEventListener('scroll', function () {
            clearTimeout(warte);
            warte = setTimeout(function () { markiere(aktiv()); }, 90);
          }, { passive: true });
        }

        // Der Variantenwechsel setzt das Bild der ersten Folie. Steht die Bahn
        // dann auf Folie 3, sieht niemand die Aenderung — also zurueckfahren.
        stage.addEventListener('sx:variant-image', function () { zeige(0); markiere(0); });
      });
    });
  }

  /* --- Menge ------------------------------------------------------------ */

  function qty() {
    each('[data-sx-qty-wrap]', function (wrap) {
      var input = wrap.querySelector('[data-sx-qty]');
      if (!input) return;

      each('[data-sx-qty-step]', function (btn) {
        once(btn, 'Qty', function () {
          btn.addEventListener('click', function () {
            var step = parseInt(btn.getAttribute('data-sx-qty-step'), 10) || 0;
            var min = Number(input.min || 1);
            var max = input.max ? Number(input.max) : Infinity;
            var increment = Number(input.step || 1);
            var next = Math.min(max, Math.max(min, (Number(input.value) || min) + step * increment));
            input.value = next;
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      }, wrap);
    });
  }

  /* --- Bundle „Routine vervollständigen" -------------------------------- */

  // Lieferdatum-Schaetzung. 1:1 aus `sx-main-product` des Live-Themes:
  // Werktage Mo-Fr, Bestellschluss als Stunde, danach zaehlt der Folgetag.
  function delivery() {
    each('[data-sx-deliv]', function (el) {
      once(el, 'Deliv', function () {
        var cutoff = parseInt(el.getAttribute('data-cutoff'), 10);
        if (isNaN(cutoff)) cutoff = 14;
        var lead = parseInt(el.getAttribute('data-lead'), 10);
        if (isNaN(lead)) lead = 2;

        var now = new Date(), d = new Date(now), added = 0;
        var late = now.getHours() >= cutoff;
        if (late) d.setDate(d.getDate() + 1);
        while (added < lead) {
          d.setDate(d.getDate() + 1);
          var wd = d.getDay();
          if (wd !== 0 && wd !== 6) added++;
        }

        var days = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
        var mon = ['Jan', 'Feb', 'März', 'Apr', 'Mai', 'Juni', 'Juli', 'Aug', 'Sept', 'Okt', 'Nov', 'Dez'];
        var dateStr = days[d.getDay()] + ', ' + d.getDate() + '. ' + mon[d.getMonth()];

        if (late) {
          el.innerHTML = 'Geliefert bis <b>' + dateStr + '</b>';
        } else {
          var ms = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoff, 0, 0) - now;
          var hrs = Math.floor(ms / 3600000), mins = Math.floor((ms % 3600000) / 60000);
          el.innerHTML = 'Bestell in <b>' + hrs + ' Std ' + mins + ' Min</b> → geliefert <b>' + dateStr + '</b>';
        }
      });
    });
  }

  /* Der Gratisversand-Fortschritt auf der Produktseite rechnete nur die
     Auswahl AUF der Seite. Wer schon 50 EUR im Warenkorb hatte, las dort
     trotzdem "Noch 44,01 EUR bis zum Gratisversand" — gemessen 22.09.2026.
     Warenkorb und Schublade rechnen gegen cart.total_price; die Produktseite
     tut es jetzt auch. Nur der Versandbalken zaehlt den Korb mit, die
     Preisanzeige am Kaufknopf bleibt die Auswahl. */
  var sxCartCents = 0;
  var sxCartLaeuft = false;

  function sxCartHolen(danach) {
    if (sxCartLaeuft) return;
    sxCartLaeuft = true;
    var url = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c && typeof c.total_price === 'number') sxCartCents = c.total_price; })
      .catch(function () { /* ohne Wert rechnet die Leiste wie bisher nur die Auswahl */ })
      .then(function () { sxCartLaeuft = false; if (danach) danach(); });
  }

  function bundle() {
    each('[data-sx-bundle]', function (root) {
      var out = root.querySelector('[data-sx-bundle-total]');
      var base = parseInt(root.getAttribute('data-base-price'), 10) || 0;
      var fmt = root.getAttribute('data-money') || '{{amount}}';
      var qtyInput = document.querySelector('[data-sx-qty]');

      function total() {
        var count = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        base = Number(root.getAttribute('data-base-price')) || 0;
        var sum = base * count;
        each('[data-sx-bundle-box][aria-checked="true"]', function (b) {
          sum += parseInt(b.getAttribute('data-price'), 10) || 0;
        }, root);

        var text = formatMoney(sum, fmt);
        if (out) out.textContent = text;
        each('[data-sx-atc-total]', function (el) { el.textContent = text; });

        // Gratisversand-Fortschritt. Rechnet gegen dieselbe Summe wie der
        // Kaufknopf, damit ein angehakter Upsell die Leiste sofort bewegt.
        //
        // 14.10.2026: „Gratisversand erreicht" stand auch bei leerem Korb, sobald
        // die Auswahl allein 69 € erreichte — auf allen drei Set-Seiten also
        // immer. „Erreicht" gilt jetzt nur für den echten Korb; alles, was erst
        // mit dem Artikel auf dieser Seite passiert, sagt das auch so.
        var mehrere = count > 1 || !!root.querySelector('[data-sx-bundle-box][aria-checked="true"]');
        each('[data-sx-ship]', function (el) {
          var thr = parseInt(el.getAttribute('data-sx-ship'), 10) || 0;
          if (!thr) return;
          var txt = el.querySelector('[data-sx-ship-text]');
          var fill = el.querySelector('[data-sx-ship-fill]');
          var mit = mehrere ? 'dieser Auswahl' : 'diesem ' + (el.getAttribute('data-sx-ship-noun') || 'Artikel');
          // Auswahl auf der Seite PLUS das, was schon im Warenkorb liegt.
          var gesamt = sum + sxCartCents;
          var pct = Math.min(100, Math.round((gesamt / thr) * 100));
          if (fill) fill.style.width = pct + '%';
          if (txt) {
            txt.textContent = sxCartCents >= thr
              ? 'Gratisversand erreicht'
              : gesamt >= thr
                ? 'Mit ' + mit + ' versandkostenfrei'
                : 'Mit ' + mit + ' noch ' + formatMoney(thr - gesamt, fmt) + ' bis zum Gratisversand';
          }
        });
      }

      each('[data-sx-bundle-box]', function (box) {
        once(box, 'Bundle', function () {
          box.addEventListener('click', function () {
            var wasOn = box.getAttribute('aria-checked') === 'true';
            box.setAttribute('aria-checked', wasOn ? 'false' : 'true');
            box.textContent = wasOn ? '' : '✓';

            var row = box.closest('[data-sx-bundle-row]');
            if (row) {
              // Abgewählte Zeilen dürfen nicht mitgepostet werden.
              each('input[type=hidden]', function (i) { i.disabled = wasOn; }, row);
            }
            total();
          });
        });
      }, root);

      if (qtyInput) once(qtyInput, 'BundleQty', function () {
        qtyInput.addEventListener('input', total);
      });

      once(root, 'BundleVariant', function () {
        document.addEventListener('sx:variant', function () { if (root.isConnected) total(); });
      });
      once(root, 'BundleCart', function () {
        // Die Schublade meldet jede Aenderung; danach stimmt der Korbwert wieder.
        var frisch = function () { sxCartHolen(function () { if (root.isConnected) total(); }); };
        document.addEventListener('sx2:cart:updated', frisch);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, frisch);
        }
      });
      total();
      sxCartHolen(function () { if (root.isConnected) total(); });
    });
  }

  /* --- Sticky Add-to-Cart ------------------------------------------------ */

  var stickyBars = [];

  /* Mobil-Pass 28.09.2026: Die Leiste stand ab 620px Scroll immer da — auf
     dem Telefon also auch, während der Kaufknopf der Buy-Box selbst im Bild
     war: zwei „In den Warenkorb" übereinander. Sie weicht jetzt, solange der
     Knopf ihres Formulars (form="…") sichtbar ist. */
  function stickyMain(bar) {
    var btn = bar.querySelector('[form]');
    var form = btn && document.getElementById(btn.getAttribute('form'));
    return form ? (form.querySelector('[data-sx-atc]') || form) : null;
  }

  function stickyCheck() {
    for (var i = 0; i < stickyBars.length; i++) {
      var bar = stickyBars[i];
      if (!bar.isConnected) continue;
      var main = bar._sxMain;
      var mainInView = false;
      if (main && main.isConnected) {
        var r = main.getBoundingClientRect();
        /* Unter dem Cookie-Banner zählt der Knopf nicht als sichtbar
           (Höhe aus sx2-consent-captcha), sonst wiche die Leiste einem
           verdeckten Knopf. */
        var covered = parseFloat(document.documentElement.style.getPropertyValue('--sx-consent-offset')) || 0;
        mainInView = r.height > 0 && r.bottom > 0 && r.top < window.innerHeight - covered;
      }
      var visible = window.scrollY > bar._sxOffset && !mainInView;
      bar.classList.toggle('is-in', visible);
      bar.inert = !visible;
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }
  }

  function sticky() {
    each('[data-sx-sticky]', function (bar) {
      bar._sxOffset = parseInt(bar.getAttribute('data-offset'), 10) || 620;
      bar._sxMain = stickyMain(bar);
      once(bar, 'Sticky', function () { stickyBars.push(bar); });
    });
    stickyBars = stickyBars.filter(function (b) { return b.isConnected; });
    stickyCheck();
  }

  window.addEventListener('scroll', stickyCheck, { passive: true });
  document.addEventListener('sx:consent-offset', stickyCheck);

  /* --- Hauttyp-Finder ---------------------------------------------------- */

  function quiz() {
    each('[data-sx-quiz]', function (root) {
      once(root, 'Quiz', function () {
        /* Die Ergebnis-Bloecke tragen dasselbe data-sx-quiz-step wie die Fragen.
           Ohne :not(...) zaehlte steps sie mit (5 statt 3), die letzte Antwort
           lief in show(3) — und show() versteckt Ergebnisse gleich wieder.
           Nach Frage 3 war damit alles hidden. 25.08. */
        var steps = Array.prototype.slice.call(
          root.querySelectorAll('[data-sx-quiz-step]:not([data-sx-quiz-result])')
        );
        var results = Array.prototype.slice.call(root.querySelectorAll('[data-match-tags]'));
        var picked = [];

        function show(i) {
          steps.forEach(function (s, n) { s.hidden = n !== i; });
          results.forEach(function (r) { r.hidden = true; });
        }

        each('[data-sx-quiz-opt]', function (btn) {
          btn.addEventListener('click', function () {
            var tag = btn.getAttribute('data-tag') || '';
            var step = btn.closest('[data-sx-quiz-step]');
            var index = parseInt(step.getAttribute('data-index'), 10) || 0;

            picked[index] = tag;

            if (index + 1 < steps.length) {
              show(index + 1);
              steps[index + 1].setAttribute('tabindex', '-1');
              steps[index + 1].focus();
              return;
            }

            // Letzte Frage beantwortet: Ergebnis mit den meisten Treffern.
            steps.forEach(function (s) { s.hidden = true; });
            var best = null;
            var bestScore = -1;
            results.forEach(function (r) {
              var want = (r.getAttribute('data-match-tags') || '').split(',');
              var score = 0;
              want.forEach(function (w) {
                if (picked.indexOf(w.trim()) > -1) score++;
              });
              if (score > bestScore) { bestScore = score; best = r; }
            });
            if (!best && results.length) best = results[0];
            if (best) {
              best.hidden = false;
              each('[data-sx-quiz-attrs]', function (i) { i.value = picked.join(' · '); }, best);
              best.setAttribute('tabindex', '-1');
              best.focus();
            }
          });
        }, root);

        /* Zurueck zu Frage 1, ohne Reload — Antworten aendern. */
        each('[data-sx-quiz-restart]', function (btn) {
          btn.addEventListener('click', function () {
            picked.length = 0;
            show(0);
            steps[0].setAttribute('tabindex', '-1');
            steps[0].focus();
          });
        }, root);

        show(0);
      });
    });
  }

  /* --- Start ------------------------------------------------------------- */

  function init() {
    reveal();
    menu();
    clock();
    accordions();
    variants();
    gallery();
    qty();
    bundle();
    delivery();
    sticky();
    quiz();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Der Theme-Editor tauscht Sections im laufenden DOM aus. Die once()-Marken
  // sitzen am Element, deshalb ist ein erneuter Durchlauf gefahrlos.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () {
    stickyBars = stickyBars.filter(function (b) { return b.isConnected; });
  });
})();

/* =========================================================================
   ui-carousel — Pfeile fuer die waagerechte Produktbahn (09.09.2026)

   Die Bahn selbst ist reines scroll-snap und funktioniert ohne dieses
   Skript: wischen und Tastatur-Scrollen gehen immer. Nur die Pfeile
   brauchen JS, deshalb stehen sie im Markup auf `hidden` und werden hier
   eingeblendet — ein toter Knopf ist schlimmer als keiner.

   Ein Klick schiebt um genau eine Kartenbreite plus Fuge. Am Ende der Bahn
   wird der jeweilige Pfeil deaktiviert, damit klar ist, dass Schluss ist.
   ========================================================================= */
(function () {
  'use strict';

  function step(rail) {
    var first = rail.firstElementChild;
    var gap = parseFloat(getComputedStyle(rail).columnGap) || 10;
    return (first ? first.getBoundingClientRect().width : 260) + gap;
  }

  function smooth() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  }

  function sync(rail, buttons) {
    // 2px Toleranz: subpixel-genaue Scrollpositionen treffen das Maximum nie exakt.
    var max = rail.scrollWidth - rail.clientWidth - 2;
    buttons.forEach(function (btn) {
      var back = Number(btn.dataset.uiCarouselDir) < 0;
      btn.disabled = back ? rail.scrollLeft <= 2 : rail.scrollLeft >= max;
    });
  }

  function init() {
    document.querySelectorAll('[data-ui-carousel]').forEach(function (root) {
      if (root.dataset.uiCarouselReady === '1') return;
      var rail = root.querySelector('.ui-carousel__content');
      if (!rail) return;
      var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-ui-carousel-dir]'));
      if (!buttons.length) return;
      root.dataset.uiCarouselReady = '1';

      buttons.forEach(function (btn) {
        btn.hidden = false;
        btn.addEventListener('click', function () {
          rail.scrollBy({ left: step(rail) * Number(btn.dataset.uiCarouselDir), behavior: smooth() });
        });
      });

      var pending;
      rail.addEventListener('scroll', function () {
        window.clearTimeout(pending);
        pending = window.setTimeout(function () { sync(rail, buttons); }, 60);
      }, { passive: true });
      window.addEventListener('resize', function () { sync(rail, buttons); }, { passive: true });
      sync(rail, buttons);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
